const readQuran = [
  { label: "Daily", value: "Daily" },
  { label: "Only During Friday", value: "Only During Friday" },
  { label: "Occasionally", value: "Occasionally" },
  { label: "Rarely", value: "Rarely" },
  { label: "Never Read", value: "Never Read" },
];
export default readQuran;
